import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import { FormButtonGroup } from "../../../../components/form/FormButtonGroup";

interface ReturnAppointmentConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (isReturn: boolean) => void;
  appointmentDetails: {
    date: string;
    daysDifference: number;
    returnDays: number;
  } | null;
}

/**
 * Modal de confirmação para consultas de retorno
 * 
 * Este componente exibe um diálogo perguntando ao usuário se a consulta atual
 * deve ser considerada como uma consulta de retorno (cortesia), baseado em
 * um atendimento anterior detectado dentro do período de retorno configurado.
 */
export function ReturnAppointmentConfirmationDialog({
  open,
  onClose,
  onConfirm,
  appointmentDetails
}: ReturnAppointmentConfirmationDialogProps) {
  // Não renderizar o conteúdo interno se não houver detalhes, mas manter o Dialog
  const hasDetails = appointmentDetails !== null;
  
  return (
    <Dialog
      open={open && hasDetails}
      onClose={() => {
        onClose();
      }}
      maxWidth="sm"
      fullWidth
    >
      {hasDetails && (
        <>
          <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
            Consulta de Retorno
          </DialogTitle>
          <DialogContent>
            <Stack spacing={2} sx={{ py: 2 }}>
              <Typography variant="body1" align="center">
                Foi detectado um atendimento anterior em {appointmentDetails.date}.
              </Typography>
              <Typography variant="body1" align="center">
                Esta consulta está dentro do período de retorno de {appointmentDetails.returnDays} dias 
                (passaram-se {appointmentDetails.daysDifference} dias desde o último atendimento).
              </Typography>
              <Typography variant="body1" align="center" fontWeight="bold">
                Deseja considerar esta como uma consulta de retorno (cortesia)?
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions sx={{ p: 2, width: '100%' }}>
            <FormButtonGroup
              onGoBackButtonClick={() => {
                onConfirm(false);
              }}
              onNextButtonClick={() => {
                onConfirm(true);
              }}
              goBackButtonText="Não"
              nextButtonText="Sim"
              direction="row-reverse"
              maxWidth={false}
            />
          </DialogActions>
        </>
      )}
    </Dialog>
  );
} 